import { render, staticRenderFns } from "./NumberCardList.vue?vue&type=template&id=07c2315e"
import script from "./NumberCardList.vue?vue&type=script&lang=js"
export * from "./NumberCardList.vue?vue&type=script&lang=js"
import style0 from "./NumberCardList.vue?vue&type=style&index=0&id=07c2315e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports